const ACTIVE_CLASS = 'is-active'
const ACTIVE_MODIFIER_CLASS = 'redesign-page-nav__link--active'

const normalizePathname = pathname => {
  const normalizedPathname = pathname.replace(/\/+$/, '')

  return normalizedPathname || '/'
}

export default (element) => {
  const currentPathname = normalizePathname(window.location.pathname)
  const links = element.querySelectorAll('.redesign-page-nav__link')

  for (const link of links) {
    const linkPathname = normalizePathname(new URL(link.href, window.location.origin).pathname)
    const isActive = linkPathname === currentPathname

    link.classList.toggle(ACTIVE_CLASS, isActive)
    link.classList.toggle(ACTIVE_MODIFIER_CLASS, isActive)

    if (isActive) {
      link.setAttribute('aria-current', 'page')
    } else {
      link.removeAttribute('aria-current')
    }
  }
}
